module.exports = __webpack_public_path__ + "img/186-421d67.png";